<!-- IncidentsView.vue -->
<template>
  <div class="incidents-view">
    <div class="header-section">
      <div class="title-container">
        <h1>Gestión de Incidencias</h1>
        <button class="primary-button" @click="openCreateModal">
          <Plus />
          Nueva Incidencia
        </button>
      </div>
      <IncidentSearchComponent />
    </div>
    
    <!-- <IncidentFilters @filter="handleFilter" /> -->

    <IncidentListComponentAux />
    <!-- <IncidentListComponentAux /> -->
    <IncidentFormComponent
      :show="isFormModalOpen"
      @close="handleCloseModal"
      @submit="handleFormSubmit"
    />

  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from 'vue';
import { useIncidentStore } from '@/stores/useIncidentStore';
/* import IncidentActions from '@/components/incidents/IncidentActions.vue';
import IncidentFilters from '@/components/incidents/IncidentFilters.vue'; */
import IncidentListComponent from '@/components/incidents/IncidentListComponent.vue';
import IncidentSearchComponent from '@/components/incidents/IncidentSearchComponent.vue';
import IncidentFormComponent from '@/components/incidents/IncidentFormComponent.vue';
/* import IncidentFormModal from '@/components/incidents/IncidentFormModal.vue'; */
import type { Incident } from '@/types/incidentsTypes';

import { Plus } from 'lucide-vue-next';
import IncidentListComponentAux from '@/components/incidents/IncidentListComponentAux.vue';

// Store
const incidentStore = useIncidentStore();

// State
const isFormModalOpen = ref(false);
const selectedIncident = ref<Incident | null>(null);
/* const currentFilters = ref<IncidentFilters>({}); */

// Computed
const filteredIncidents = computed(() => {
  return incidentStore.incidents.filter(incident => {
    // Lógica de filtrado según currentFilters
  });
});

// Handlers
const handleFormSubmit = async () => {
  await incidentStore.fetchIncidents();
};

const handleCloseModal = () => {
  isFormModalOpen.value = false;
};

const openCreateModal = () => {
  selectedIncident.value = null;
  isFormModalOpen.value = true;
};

const openEditModal = (incident: Incident) => {
  selectedIncident.value = incident;
  isFormModalOpen.value = true;
};
/* 
const handleFormSubmit = async (formData: IncidentForm) => {
  if (selectedIncident.value) {
    await incidentStore.updateIncident(formData);
  } else {
    await incidentStore.createIncident(formData);
  }
  isFormModalOpen.value = false;
}; */

const refreshIncidents = async () => {
  await incidentStore.fetchIncidents();
};

// Inicialización
onMounted(() => {
  incidentStore.fetchIncidents();
});
</script>

<style scoped>
.incidents-view {
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
}

.header-section {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.title-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
}

.primary-button {
  background: #2196F3;
  color: white;
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: background 0.3s ease;
  font-size: 1rem;
  order: 2; /* Para móviles lo ponemos debajo */
}

.primary-button:hover {
  background: #1976D2;
}

@media (min-width: 768px) {
  .primary-button {
    order: 1; /* En desktop volvemos al orden normal */
  }
}
</style>
